import type { SectorEcosystemOverview } from "../../../../../shared/sectorEcosystemOverview";
import trpc from "@/shared/utils/trpc";
import { handleTrpcError } from "@/shared/utils/trpc/handletrpcError.util";

export async function fetchSectorEcosystemOverview(slug: string): Promise<SectorEcosystemOverview> {
  try {
    const res = await trpc.discover.getSectorEcosystemOverview.query({ slug });
    return res.overview;
  } catch (err) {
    handleTrpcError(err);
    throw err;
  }
}
